import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/assets/icon/icon_left.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Ionic logo"
  })
], -1)
const _hoisted_2 = { class: "password_row" }
const _hoisted_3 = { class: "password_row" }
const _hoisted_4 = { class: "password_row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    position: "stacked",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Usuario")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.authStore.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authStore.username) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    position: "stacked",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Contraseña Actual")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ion_input, {
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      type: _ctx.typePassword
                    }, null, 8, ["modelValue", "type"]),
                    _createElementVNode("a", {
                      class: "type-toggle",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShow()))
                    }, [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "show-option",
                        icon: _ctx.eyeOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, _ctx.showPassword]
                      ]),
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "hide-option",
                        icon: _ctx.eyeOffOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.showPassword]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    position: "stacked",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Contraseña Nueva")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_input, {
                      modelValue: _ctx.newPassword,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPassword) = $event)),
                      type: _ctx.typeNewPassword
                    }, null, 8, ["modelValue", "type"]),
                    _createElementVNode("a", {
                      class: "type-toggle",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleNewShow()))
                    }, [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "show-option",
                        icon: _ctx.eyeOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, _ctx.showNewPassword]
                      ]),
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "hide-option",
                        icon: _ctx.eyeOffOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.showNewPassword]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    position: "stacked",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Repetir Contraseña Nueva")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_ion_input, {
                      modelValue: _ctx.newPasswordRepeat,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPasswordRepeat) = $event)),
                      type: _ctx.typeNewPasswordRepeat
                    }, null, 8, ["modelValue", "type"]),
                    _createElementVNode("a", {
                      class: "type-toggle",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleNewRepeatShow()))
                    }, [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "show-option",
                        icon: _ctx.eyeOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, _ctx.showNewPasswordRepeat]
                      ]),
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "hide-option",
                        icon: _ctx.eyeOffOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.showNewPasswordRepeat]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    size: "default",
                    class: "login-button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePassword()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Guardar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}